"use client";

import { Award, HeartPulse, LifeBuoy, ShieldCheck, Users, Wrench } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Quality() {
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: statsRef,
    isVisible: statsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const badges = [{
    icon: Award,
    title: "UL 508A Certified",
    desc: "Adhering to strict industrial safety standards."
  }, {
    icon: LifeBuoy,
    title: "Precision Quality Control",
    desc: "Rigorous inspection for every component."
  }, {
    icon: HeartPulse,
    title: "Material Integrity",
    desc: "Only industrial-grade, durable materials used."
  }, {
    icon: Users,
    title: "Expert Craftsmanship",
    desc: "Decades of experience in precision marking."
  }, {
    icon: Wrench,
    title: "Advanced Equipment",
    desc: "State-of-the-art laser and CNC technology."
  }, {
    icon: ShieldCheck,
    title: "Compliance Guaranteed",
    desc: "Meeting all regulatory and safety requirements."
  }];
  return;
}